import { Component, Input } from "@angular/core";
import { scaleInOut } from "src/app/shared/utilities/animations";
import { environment } from "src/environments/environment";

@Component({
  selector: "myqq-b2c-card",
  templateUrl: "./b2c-card.component.html",
  styleUrls: ["./b2c-card.component.scss"],
  animations: [scaleInOut("rollDownUp", 200)],
})
export class B2cComponent {
  cdnHost = environment.cdnHost;
  b2cCardImg = `${environment.cdnHost}/img/b2c/b2c-benefits-home-card.svg`;
  @Input() companyName: string;
  @Input() contractDescription: string;
}
